import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageChanger from "../../Helpers/Components/Pagination"
import Pagination1 from "../../Helpers/Components/Pagination1"
import Handler from "../../Helpers/Components/Handler"
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder"
import DatePicker from "react-multi-date-picker";
import { DropdownButton, DropdownToggle } from "../../Helpers/Components/Dropdown";
import { formatPhoneNo, getCookie, toReadableTime } from "../../Helpers/Utils";
import * as FileSaver from "file-saver";
import XLSX from 'sheetjs-style';
import { toast } from "react-toastify";
import Modal from "../../Helpers/Components/Modal";
import ExcelPreview from "../../Helpers/Components/ExcelPreview";
import Select from 'react-select'
import Creatable from 'react-select/creatable'

const List = () => {
    const { pageNo, active } = useParams()
    const navigate = useNavigate()
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [custDetails, setCustDetails] = useState([])
    const [callList, setCallList] = useState([])
    const [history, setHistory] = useState([])
    const [next1, setNext1] = useState(false)
    const [openHistory, setOpenHistory] = useState(false)
    const [total, setTotal] = useState(0)
    const [search, setSearch] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsgeet.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const handleKeyDown = (event) => { if (event.key === "Enter") { event.preventDefault(); handleSearch(); } };
    const [filter, setFilter] = useState({ sortBy: "timestamp", sort: false, search: "", subadminId: "All", type: "All", count: 10 })
    const [page, setPage] = useState(1)
    const [phone, setPhone] = useState({})
    const [convertSrcNumber, setConvertSrcNumber] = useState("")
    const [leadConvertModal, setLeadConvertModal] = useState(false)
    const phoneOptions = [
        { label: "9566280480 - 6280", value: "9566280480" },
        { label: "9566180480 - 6180", value: "9566180480" },
    ]
    const [checkDate, setCheckDate] = useState()
    const calendarRef = useRef();
    const [downloadData, setDownloadData] = useState({ open: false, from: "", to: "" })
    const [preview, setPreview] = useState({ open: false, rows: [], from: "", to: "" })
    const closePreview = () => setPreview({ open: false, rows: [], from: "", to: "" })
    const previewColumns = ["Phone No", "Name", "Phone Type", "Followed By", "Total Calls", "Missed Calls", "Received Calls", "Outgoing Calls", "Total Duration", "First Call", "Last Call", "Last Call Type"].map((h) => ({ header: h.toUpperCase(), key: h, width: h.includes("Call") && h.length > 11 ? 18 : 14 }))
    const closeDownload = () => setDownloadData({ open: false, from: "", to: "" })
    const setPageNo = (value) => navigate(`/call/${active}/${value}`)
    const handleOpen = () => { if (calendarRef.current) { calendarRef.current.openCalendar(); } };
    const sort = (sortBy, sort) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, sortBy: sortBy, sort: sort }))
    }
    const getLeadDetails = async () => {
        setLoading(true)
        const response = await Handler({
            method: "post", url: `/lead/phone/${active === "all" ? "list" : "missed"}/${pageNo}?count=${filter?.count || 10}`,
            data: {
                ...(appliedSearch ? { search: appliedSearch } : {}),
                ...(checkDate?.length ? { from: moment(new Date(checkDate[0]))?.format("DD-MM-YYYY"), to: checkDate?.length >= 2 ? moment(new Date(checkDate[1]))?.format("DD-MM-YYYY") : moment(new Date(checkDate[0]))?.format("DD-MM-YYYY") } : {}),
                sort: filter?.sort,
                sortBy: filter?.sortBy,
                ...(filter?.subadminId !== "All" ? { subadminId: filter?.subadminId } : {}),
                ...(filter?.type !== "All" ? { type: filter?.type } : {}),
            }
        })
        if (response?.success) {
            setCustDetails(response?.data?.current)
            setNext(response?.data?.next)
            setTotal(response?.data?.total)
        } else {
            setCustDetails([])
            setNext(false)
            setTotal(0)
        }
        setLoading(false)
    }
    const getLeadList = async () => {
        const response = await Handler({ method: "get", url: `/booking/lead-list`, })
        if (response?.success) {
            setCallList([...(response?.data?.length ? response?.data?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : [])])
        } else {
            setCallList([])
        }
    }
    const clearFilter = () => {
        setFilter({ count: 10, sortBy: "timestamp", sort: false, search: "", type: "All", remarks: "All", subadminId: "All", src: "All", status: "All" })
        setCheckDate({})
        setPageNo(1)
    }
    const exportToExcel = async () => {
        if (!downloadData?.from) return toast.error("From date is required")
        if (!downloadData?.to) return toast.error("To date is required")
        const data = {
            from: moment(new Date(downloadData.from)).format("DD-MM-YYYY"),
            to: moment(new Date(downloadData.to)).format("DD-MM-YYYY"),
            ...(active === "missed" ? { missedOnly: true } : {}),
        }
        setLoading(true)
        const response = await Handler({ method: 'post', data, url: `/lead/download/calls` })
        setLoading(false)
        if (response?.success) {
            const when = (value) => value ? moment(new Date(value)).format('DD/MM/YYYY - hh:mm A') : "-"
            const rows = response?.data?.length ? response?.data?.map(value => {
                return {
                    "Phone No": formatPhoneNo(value?.number) || "-",
                    "Name": value?.name || "-",
                    "Phone Type": value?.numberType || "-",
                    "Followed By": value?.subadminId || "-",
                    "Total Calls": value?.totalCalls || 0,
                    "Missed Calls": value?.missedCalls || 0,
                    "Received Calls": value?.receivedCalls || 0,
                    "Outgoing Calls": value?.outgoingCalls || 0,
                    "Total Duration": value?.totalDuration ? toReadableTime(Number(value?.totalDuration)) : "-",
                    "First Call": when(value?.firstCallAt),
                    "Last Call": when(value?.lastCallAt),
                    "Last Call Type": value?.lastCallType?.split(".")[1] || "-",
                }
            }) : []
            setPreview({ open: true, rows, from: data.from, to: data.to })
            closeDownload()
        } else {
            toast.error(response?.message)
        }
    }
    const downloadExcel = () => {
        const ws = XLSX?.utils?.json_to_sheet(preview.rows);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blob, `Calls ${preview.from}${preview.from !== preview.to ? ` - ${preview.to}` : ""}` + fileExtension);
    }
    const handleList = async () => {
        setHistory([])
        setLoading(true)
        setNext1(false)
        const historyDetails = await Handler({ data: { phone: phone?.number }, url: `/lead/history/${page - 1}`, method: "POST" })
        if (historyDetails?.success) {
            setHistory(historyDetails?.data?.current)
            setNext1(historyDetails?.data?.next)
        } else {
            setHistory([])
        }
        setLoading(false)
        setOpenHistory(true)
    }
    const handlePage = (value) => {
        setPage(value)
        handleList()
    }
    const handleNumberType = async (value) => {
        setLoading(true)
        const response = await Handler({ method: "PATCH", url: `/lead/update/numbertype/${phone?.phoneLeadId}?numberType=${value}`,  data: {...(value === "lead" && convertSrcNumber ? {srcNumber :encodeURIComponent(convertSrcNumber) } : {})}})
        if (response?.success) {
            toast.success(response.message)
            getLeadDetails()
            setOpenHistory(false)
            setConvertSrcNumber("")
            setLeadConvertModal(false)
        } else {
            toast.error(response.message)
        }
        setLoading(false)
    }
    const openLeadConvert = () => { setConvertSrcNumber(""); setLeadConvertModal(true) }
    const handleSearch = () => {
        setPageNo(1);
        setAppliedSearch(search);
    };
    useEffect(() => {
        if (phone?.number) { setPage(1); handleList() }
    }, [phone])
    useEffect(() => {
        getLeadList()
    }, [])
    useEffect(() => {
        getLeadDetails()
    }, [pageNo, filter, checkDate, appliedSearch])
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Call List</h5>
            <div className="layout-card mt-2">
                <div className="row justify-content-between align-items-center mb-3">
                    <div className="col-lg-8">
                        <ul className="nav nav-underline">
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "all" ? "active-tabs" : ""}`} onClick={() => { setSearch(""); setAppliedSearch("") }} aria-current="page" href="/call/all/1">All</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "missed" ? "active-tabs" : ""}`} onClick={() => { setSearch(""); setAppliedSearch("") }} aria-current="page" href="/call/missed/1">Missed</a>
                            </li>
                        </ul>
                    </div>
                    {
                        loading ? "" :
                            <div className="col-lg-4 text-end ">
                                <i className="fa-solid fa-download cursor-pointer fs-5" title="Download calls" onClick={() => setDownloadData({ open: true, from: "", to: "" })}></i>
                            </div>
                    }

                </div>
                {
                    active === "all" ?
                        <>

                            <div className="row justify-content-between align-items-center">
                                <div className="col-lg-4">
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="input-group">
                                            <input type="text" className="form-control search-input" onKeyDown={handleKeyDown} autoComplete="off" placeholder="Search..." value={search} onChange={(e) => { if (e.target.value) setSearch(e.target.value); else { setSearch(""); setAppliedSearch(""); setPageNo(1); } }} name="search" />
                                            <span className="input-group-text cancel-icon">{search && (<i className="fa-solid fa-circle-xmark cursor-pointer text-theme" onClick={() => { setSearch(""); setAppliedSearch(""); setPageNo(1); }} />)}</span>
                                        </div>
                                        <button className="btn btn-sm btn-theme" onClick={handleSearch}>Search</button>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 fw-bold d-flex align-items-center flex-wrap gap-3">Total Count : {total || 0} <button onClick={clearFilter} className="btn btn-theme btn-sm">Clear Filter</button></div>
                        </>
                        : ""
                }
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >

                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "timestamp" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("timestamp", false)} >▲</i><i className={filter?.sortBy === "timestamp" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("timestamp", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}>Log At</button> </div></th>
                                {/* <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "phoneLeadId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("phoneLeadId", false)} >▲</i><i className={filter?.sortBy === "phoneLeadId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("phoneLeadId", true)} >▼</i></div> ID </div></th> */}
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "name" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("name", false)} >▲</i><i className={filter?.sortBy === "name" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("name", true)} >▼</i></div> Name </div></th>
                                <th>Phone Type</th>
                                <th>Call Type</th>
                                <th>Phone No</th>
                                <th>
                                    <DropdownToggle label={
                                        <>
                                            Followed By <i className="fa-solid fa-caret-down"></i>
                                        </>
                                    }>
                                        <DropdownButton label="All" className={`${filter?.subadminId === "All" ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, subadminId: "All" })) }} />
                                        {
                                            callList?.length ?
                                                callList?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.label} className={`${filter?.subadminId === element?.value ? "active-option" : ""} text-uppercase`} onClick={() => { setFilter((prev) => ({ ...prev, subadminId: element?.value })) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th>Duration</th>
                                <th><DropdownToggle label={
                                    <>
                                        Type <i className="fa-solid fa-caret-down"></i>
                                    </>
                                }>
                                    <DropdownButton label="All" className={`${filter?.type === "All" ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, type: "All" })) }} />
                                    <DropdownButton label="Spam" className={`${filter?.type === "spam" ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, type: "spam" })) }} />
                                    <DropdownButton label="Lead" className={`${filter?.type === "lead" ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, type: "lead" })) }} />
                                    <DropdownButton label="Personal" className={`${filter?.type === "personal" ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, type: "personal" })) }} />

                                </DropdownToggle></th>
                                <th> History </th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (custDetails && custDetails?.length !== 0 ? custDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${value?.callType?.split(".")[1] === "missed" ? "text-red" : ""} ${value?.callType?.split(".")[1] === "outgoing" && Number(value?.duration) === 0 ? "bg-yellow" : ""}`}>

                                            <td>{value?.timestamp ? moment(new Date(value?.timestamp)).format('DD/MM/YYYY - hh:mm A') : ""}</td>
                                            {/* <td>{value?.phoneLeadId}</td> */}
                                            <td className="text-capitalize">{(value?.name || "-")}</td>
                                            <td> <div className={`badge ${value?.phoneType === "New" ? "badge-primary" : value?.phoneType === "Customer" ? "badge-success" : "badge-info"}`}>{value?.phoneType || ""}</div></td>
                                            <td className="text-capitalize" >{value?.callType?.split(".")[1] || ""}</td>
                                            <td className="text-uppercase">{formatPhoneNo(value?.number) || ""}</td>
                                            <td className="text-capitalize">{value?.subadminId || ""}</td>
                                            <td>{value?.duration ? toReadableTime(Number(value?.duration)) : ""}</td>
                                            <td className="text-capitalize">{value?.numberType || ""}</td>
                                            <td><i className="fa-solid fa-eye cursor-pointer" onClick={() => { setPhone(value) }}></i></td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={9}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={9} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilter(prev => ({ ...prev, count: Number(selectedoption?.value) }))
                            setPageNo(1)
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue={`call/${active}`} />
            </div>
            <DatePicker
                ref={calendarRef}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setCheckDate(e); } }}
                value={checkDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => setCheckDate({}),
                    },
                ]}
            />
            <Modal header="Download" centered={true} onShow={downloadData?.open} toggle={closeDownload} overlayToggle={closeDownload}>
                <div className="text-center">
                    <div className="mb-3 text-start">
                        <label className="form-label">From</label>
                        <div className="filter-date datepicker-top">
                            <DatePicker portal zIndex={2000} disabled={loading} value={downloadData?.from ? new Date(downloadData.from) : ""} format="DD/MM/YYYY" onChange={(e) => setDownloadData((prev) => ({ ...prev, from: e ? new Date(e) : "", to: "" }))} />
                        </div>
                    </div>
                    <div className="mb-3 text-start">
                        <label className="form-label">To</label>
                        <div className="filter-date datepicker-top">
                            <DatePicker minDate={downloadData?.from ? new Date(new Date(downloadData.from).setHours(-1, 0, 0, 0)) : undefined} portal zIndex={2000} disabled={loading || !downloadData?.from} value={downloadData?.to ? new Date(downloadData.to) : ""} format="DD/MM/YYYY" onChange={(e) => setDownloadData((prev) => ({ ...prev, to: e ? new Date(e) : "" }))} />
                        </div>
                    </div>
                    <button className="btn btn-success" onClick={exportToExcel} disabled={loading}>{loading ? "Loading..." : "Submit"}</button>
                </div>
            </Modal>
            <Modal header="Excel Preview" fullScreen={true} onShow={preview.open} toggle={closePreview} overlayToggle={closePreview}>
                {preview.open ? <ExcelPreview columns={previewColumns} rows={preview.rows} summary={`${preview.rows.length} numbers · ${preview.from} to ${preview.to}`} onDownload={downloadExcel} /> : null}
            </Modal>
            <Modal header="History" size={'lg'} onShow={openHistory} footerClassname={'justify-content-center'} toggle={() => setOpenHistory(false)} overlayToggle={() => setOpenHistory(false)}>
                {
                    !phone.numberType ?
                        <div className="mt-2 d-flex align-items-center justify-content-center flex-wrap gap-2">
                            <button className="btn btn-danger btn-sm" onClick={() => { handleNumberType("spam") }}>Spam</button>
                            <button className="btn btn-sm btn-primary" onClick={() => { handleNumberType("personal") }}>Personal</button>
                            <button className="btn btn-sm btn-success" onClick={openLeadConvert}>Lead</button>
                            <button className="btn btn-sm btn-warning" onClick={() => { handleNumberType("customer") }}>Existing Cust</button>
                            <button className="btn btn-sm btn-secondary" onClick={() => { handleNumberType("followup") }}>Follow Up</button>
                            <button className="btn btn-sm btn-info" onClick={() => { handleNumberType("others") }}>Others</button>
                        </div>
                        : ""
                }
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "timestamp" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("timestamp", false)} >▲</i><i className={filter?.sortBy === "timestamp" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("timestamp", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}>Log At</button> </div></th>
                                {/* <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "phoneLeadId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("phoneLeadId", false)} >▲</i><i className={filter?.sortBy === "phoneLeadId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("phoneLeadId", true)} >▼</i></div> ID </div></th> */}
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "name" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("name", false)} >▲</i><i className={filter?.sortBy === "name" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("name", true)} >▼</i></div> Name </div></th>
                                <th>Phone Type</th>
                                <th>Call Type</th>
                                <th>Phone No</th>
                                <th>
                                    <DropdownToggle label={
                                        <>
                                            Followed By <i className="fa-solid fa-caret-down"></i>
                                        </>
                                    }>
                                        <DropdownButton label="All" className={`${filter?.subadminId === "All" ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, subadminId: "All" })) }} />
                                        {
                                            callList?.length ?
                                                callList?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.label} className={`${filter?.subadminId === element?.value ? "active-option" : ""} text-uppercase`} onClick={() => { setFilter((prev) => ({ ...prev, subadminId: element?.value })) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th>Duration</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (history && history?.length !== 0 ? history?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${value?.callType?.split(".")[1] === "missed" ? "bg-red" : ""} ${value?.callType?.split(".")[1] === "outgoing" && Number(value?.duration) === 0 ? "bg-yellow" : ""}`}>

                                            <td>{value?.timestamp ? moment(new Date(value?.timestamp)).format('DD/MM/YYYY - hh:mm A') : ""}</td>
                                            {/* <td>{value?.phoneLeadId}</td> */}
                                            <td className="text-capitalize">{(value?.name || "-")}</td>
                                            <td> <div className={`text-capitalize badge ${!value?.numberType ? "badge-primary" : value?.phoneType === "customer" ? "badge-success" : value?.phoneType === "spam" ? "badge-danger" : "badge-info"}`}>{value?.numberType || ""}</div></td>
                                            <td className="text-capitalize" >{value?.callType?.split(".")[1] || ""}</td>
                                            <td className="text-uppercase">{formatPhoneNo(value?.number) || ""}</td>
                                            <td className="text-capitalize">{value?.subadminId || ""}</td>
                                            <td>{value?.duration ? toReadableTime(Number(value?.duration)) : ""}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={8}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={8} />
                            }
                        </tbody>
                    </table>
                </div>
                <PageChanger previousValue={Number(page) > 1} nextValue={next1} current={Number(page)} checkPage={true} onPageChange={handlePage} />
            </Modal>
            <Modal header="Convert to Lead" centered={true} onShow={leadConvertModal} toggle={() => setLeadConvertModal(false)} overlayToggle={() => setLeadConvertModal(false)}>
                <div className="mb-3 text-start">
                    <label className="form-label">Source Number (optional)</label>
                    <Creatable
                        value={convertSrcNumber ? (phoneOptions?.find(ele => ele.value === convertSrcNumber) || { label: convertSrcNumber, value: convertSrcNumber }) : ""}
                        onChange={(selected) => { setConvertSrcNumber(selected?.value || "") }}
                        isValidNewOption={(inputValue) => { return /^\d+$/.test(inputValue); }}
                        isClearable
                        isDisabled={loading}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        options={phoneOptions} className="mb-3" />
                </div>
                <div className="text-center">
                    <button className="btn btn-theme btn" disabled={loading} onClick={() => { handleNumberType("lead") }}>Continue</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default List;